import Vue from 'vue'

export default {
    namespaced: true,

    state: {
        fields: {
            userType: 'individual',
            fiscalDoc: 'dni',
            fiscalId: null,
            // isClient: false,
            companyName: null,
            name: null,
            surname1: null,
            surname2: null,
            email: null,
            phone: null,
            addressCountry: 'spain',
            addressProvince: 'barcelona',
            addressMunicipality: null,
            addressPostalCode: null,
            addressStreet: null,
            addressNumber: null,
            addressStairwell: null,
            addressFloor: null,
            addressDoor: null,
            iban: null,
            bank: null,
            collaborator_code: null,
            order_comments: null,
            fiscalDocAttorney: 'dni',
            fiscalIdAttorney: null,

            terms: false,
            recaptcha: null,
        },

        valid: {
            userType: true,
            fiscalDoc: true,
            fiscalId: false,
            // isClient: false,
            companyName: true,
            name: false,
            surname1: false,
            surname2: true,
            email: false,
            phone: false,
            addressCountry: true,
            addressProvince: true,
            addressMunicipality: false,
            addressPostalCode: false,
            addressStreet: false,
            addressNumber: false,
            addressStairwell: true,
            addressFloor: true,
            addressDoor: true,
            iban: true,
            bank: true,
            collaborator_code: true,
            order_comments: true,
            fiscalDocAttorney: true,
            fiscalIdAttorney: true,

            terms: false,
            recaptcha: false,
        },

        errors: {
            userType: false,
            fiscalDoc: false,
            fiscalId: false,
            // isClient: false,
            companyName: false,
            name: false,
            surname1: false,
            surname2: false,
            email: false,
            phone: false,
            addressCountry: false,
            addressProvince: false,
            addressMunicipality: false,
            addressPostalCode: false,
            addressStreet: false,
            addressNumber: false,
            addressStairwell: false,
            addressFloor: false,
            addressDoor: false,
            iban: false,
            bank: false,
            collaborator_code: false,
            order_comments: false,
            fiscalDocAttorney: false,
            fiscalIdAttorney: false,

            terms: false,
            recaptcha: false,
        }
    },

    getters: {
        formIsValid(state) {
            return Object.values(state.valid).reduce((accum, error) => accum && error, true)
        },
    },

    mutations: {
        clearErrors(state) {
            for(const error in state.errors) {
                if(!state.errors.hasOwnProperty(error)) continue;
                state.errors[error] = false
            }
        },

        setField(state, { name, value }) {
            Vue.set(state.fields, name, value)
            if(validation[name](state, value)){
                Vue.set(state.valid, name, true)
                Vue.set(state.errors, name, false)
            } else {
                Vue.set(state.valid, name, false)
            }
        },

        setError(state, { name, value }) {
            Vue.set(state.errors, name, value)
        },

        setValid(state, { name, value }) {
            Vue.set(state.valid, name, value)
        }
    }

}

const validation = {

    userType(state, value) {
        if(value === 'individual') {
            Vue.set(state.valid, 'fiscalIdAttorney', true)
        } else {
            Vue.set(state.valid, 'fiscalIdAttorney', false)
        }

        return ['individual', 'company'].includes(value)
    },

    fiscalDoc(state, value) {
        return ['dni', 'nie', 'cif', 'passport'].includes(value)
    },

    fiscalId(state, value) {
        if(!value) return false
        else if(state.fields.fiscalDoc === 'dni') return this.isValidDni(value)
        else if(state.fields.fiscalDoc === 'nie') return this.isValidNie(value)
        else if(state.fields.fiscalDoc === 'cif') return this.isValidCif(value)
        else if(state.fields.fiscalDoc === 'passport') return true
    },

    companyName(state, value) {
        if(state.fields.userType === 'company') {
            return value?.length >= 2 ?? false;
        }

        return true
    },

    name(state, value) {
        return value?.length > 2 ?? false
    },

    surname1(state, value) {
        return value?.length > 2 ?? false
    },

    surname2(state, value) {
        return true
    },

    email(state, value) {
        if(!value) return false
        return this.isValidEmailAddress(value)
    },

    phone(state, value) {
        if(!value) return false
        return this.validatePhoneNumber(value)
    },

    addressProvince(state, value) {
        return value?.length > 2 ?? false
    },

    addressMunicipality(state, value) {
        return value?.length > 2 ?? false
    },

    addressPostalCode(state, value) {
        if(!value) return false
        return this.isValidPostalCode(value)
    },

    addressStreet(state, value) {
        return value?.length > 1 ?? false
    },

    addressNumber(state, value) {
        return !!value
    },

    addressStairwell(state, value) {
        return true
    },

    addressFloor(state, value) {
        return true
    },

    addressDoor(state, value) {
        return true
    },

    iban(state, value) {
        if (!value) return true
        return this.isValidIban(value)
    },

    collaborator_code() {
        return true
    },
    order_comments(state, value) {
        return value?.length < 200 ?? false
    },

    fiscalDocAttorney(state, value) {
        return ['dni', 'nie', 'passport'].includes(value)
    },

    fiscalIdAttorney(state, value) {
        if(state.fields.userType !== 'company') return true
        if(!value) return false
        else if(state.fields.fiscalDocAttorney === 'dni') return this.isValidDni(value)
        else if(state.fields.fiscalDocAttorney === 'nie') return this.isValidNie(value)
        else if(state.fields.fiscalDocAttorney === 'passport') return true
    },

    terms(state, value) {
        return value === true
    },

    recaptcha(state, value) {
        if(value === 'not-required') {
            return true
        }
        return !!value
    },

    isValidCif(cif) {
        cif = cif.toUpperCase()
        let cifRegEx1 = /^[ABEH][0-9]{8}$/i
        let cifRegEx2 = /^[KPQS][0-9]{7}[A-J]$/i
        let cifRegEx3 = /^[CDFGJLMNRUVW][0-9]{7}[0-9A-J]$/i

        if (cifRegEx1.test(cif) || cifRegEx2.test(cif) || cifRegEx3.test(cif)) {
            let control = cif.charAt(cif.length - 1)
            let sum1 = 0
            let sum2 = 0

            for (let i = 1; i < 8; i++) {
                if (i % 2 === 0) {
                    sum1 += parseInt(cif.charAt(i))
                } else {
                    let t = (cif.charAt(i) * 2) + ''
                    let p = 0
                    for (let j = 0; j < t.length; j++) {
                        p += parseInt(t.charAt(j))
                    }
                    sum2 += p
                }
            }
            let sum3 = (sum1 + sum2) + ''
            let sum4 = (10 - parseInt(sum3.charAt(sum3.length - 1))) % 10
            let letras = 'JABCDEFGHI'
            if (control >= '0' && control <= '9')
                return (control === sum4.toString())
            else
                return (control === letras.charAt(sum4))
        } else {
            return false
        }
    },

    isValidDni(dni) {
        dni = dni.toUpperCase()

        let dniRegEx = /^[0-9]{8}[A-Z]$/i
        let controlArray = 'TRWAGMYFPDXBNJZSQVHLCKE'

        if (dniRegEx.test(dni)) {
            return controlArray[(dni.substring(0, 8) % 23)] === dni[8]
        } else {
            return false
        }
    },

    isValidNie(nie) {
        nie = nie.toUpperCase()

        let nieRegEx = /^[XYZ][0-9]{7}[A-Z]$/i
        let controlArray = 'TRWAGMYFPDXBNJZSQVHLCKE'

        if (nieRegEx.test(nie)) {

            nie = (nie[0] === 'X') ? '0' + nie.substring(1, nie.length)
                : (nie[0] === 'Y') ? '1' + nie.substring(1, nie.length)
                    : (nie[0] === 'Z') ? '2' + nie.substring(1, nie.length)
                        : nie[0]

            return controlArray[(nie.substring(0, 8) % 23)] === nie[8]
        } else {
            return false
        }
    },

    isValidEmailAddress(email) {
        email = email.toLowerCase()

        let re1 = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/i
        let re2 = /^.+@.+\.[a-z]{2,4}$/i

        return re1.test(email) && re2.test(email)
    },

    isValidIban(iban) {
        iban = iban.toUpperCase()
        iban = iban.replaceAll("-", "");
        iban = iban.replaceAll(".", "");
        iban = iban.replaceAll(" ", "");
        let re = /^([a-zA-Z]{2})(\d{22})$/
        return re.test(iban)
    },

    isValidPostalCode(postalCode) {
        let re = /^(0[1-9]|[1-4][0-9]|5[0-2])[0-9]{3}$/
        return re.test(postalCode)
    },

    isValidFixNumber(n) {
        let re = /^([89])[0-9]{8}$/
        return re.test(n)
    },

    isValidCellNumber(n) {
        let re = /^([67])[0-9]{8}$/
        return re.test(n)
    },

    validatePhoneNumber(n) {
        return this.isValidCellNumber(n) || this.isValidFixNumber(n)
    }

}
